/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ContactDTO { 
    /**
     * The patient's email associated with the patient 
     */
    email: string;
    /**
     * The patient's mobile number or the contact mobile number associated with the patient 
     */
    mobileNumber?: string;
    /**
     * The patient's telephone number or the contact telephone number associated with the patient 
     */
    telephoneNumber?: string;
}
